export enum SocialEventGroup {
    General = "General",
    MonthDetails = "MonthDetails",
    MonthDetailsEnd = "MonthDetailsEnd",
    CareReceiver = "CareReceiver",
    Child = "Child",
    CaregivingDetailPlan = "CaregivingDetailPlan",
    CaregivingDetailIntervals = "CaregivingDetailIntervals",
    CareEmployeeDeclarations = "CareEmployeeDeclarations",
    Notification = "Notification",
    Doctor = "Doctor",
    ResidenceAddresses = "ResidenceAddresses",
    PermittedOutings = "PermittedOutings",
    Note = "Note",
    AdditionalFlags = "AdditionalFlags",
}